import { useContext } from 'react';

import { ensureDefined } from '@e-socna/utils';

import { ReferencesContext } from '..';

export const useReferencesContext = () =>
  ensureDefined({ context: useContext(ReferencesContext) }).context;
